<template>
  <div>
    <NotificationReminderContainer
      :reports="reports"
      :feature-name="NOTIFICATION_FEATURES_NAME.PERIOD_ATTENDANCE"
    />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
export default {
  components: {
    NotificationReminderContainer,
  },
  page: {
    title: 'Notification | Period Attendance',
    meta: [
      {
        name: 'description',
        content: 'Period Attendance Notification System',
      },
    ],
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
      reports: ['monthly', 'weekly'],
    }
  },
}
</script>
